import { render, staticRenderFns } from "./RemoveFromQueue.vue?vue&type=template&id=523cbdfb&"
import script from "./RemoveFromQueue.vue?vue&type=script&lang=js&"
export * from "./RemoveFromQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports